<template>
  <div class="powerRecordMore-container">
    <div class="top">
      <el-button type="primary" @click="goBack">返回</el-button>
      <div class="top-container">
        <el-row class="table">
          <el-row class="table-top">
            <el-col>站址名称</el-col>
            <el-col>站址编码</el-col>
            <el-col>所属省市区县</el-col>
            <el-col>发电工单数</el-col>
            <el-col>超过24小时发电工单数</el-col>
            <el-col>完成发电工单数</el-col>
            <el-col>总发电时长（小时）</el-col>
            <el-col>总发电量（kW·h）</el-col>
            <el-col>总发电油耗（L）</el-col>
            <el-col>最近一次发电</el-col>
            <el-col>经度</el-col>
            <el-col>纬度</el-col>
            <el-col>基本直流负载（A）</el-col>
            <el-col>详细地址</el-col>
            <!-- <el-col>维护部门</el-col> -->
          </el-row>
          <el-row class="table-bottom">
            <el-col>{{ $judgeEmpty(rowData.stationName) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.stationCode) }}</el-col>
            <el-col
              >{{ $judgeEmpty(rowData.province) }}，{{
                $judgeEmpty(rowData.city)
              }}，{{ $judgeEmpty(rowData.area) }}</el-col
            >
            <el-col>{{ $judgeEmpty(rowData.dynamoCount) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.exceedDynamoCount) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.dynamoSuccessCount) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.dynamoTime) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.dynamoEnergy) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.dynamoOil) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.lastDynamoDate) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.longitude) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.latitude) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.dcLoadCurrent) }}</el-col>
            <el-col>{{ $judgeEmpty(rowData.address) }}</el-col>
            <!-- <el-col>{{ $judgeEmpty(rowData.dept) }}</el-col> -->
          </el-row>
        </el-row>
      </div>
    </div>

    <div class="bottom">
      <el-form
        size="medium"
        :inline="true"
        :model="queryForm"
        ref="queryForm"
        class="input-form-inline"
        @submit.native.prevent
      >
        <div>
          <el-form-item class="r-20" prop="subjectNum">
            <el-input
              v-model.trim="queryForm.subjectNum"
              @keyup.enter.native="query"
              placeholder="关联工单编号"
            ></el-input>
          </el-form-item>
          <el-form-item class="r-20" prop="plateNum">
            <el-input
              v-model.trim="queryForm.plateNum"
              @keyup.enter.native="query"
              placeholder="发电车辆"
            ></el-input>
          </el-form-item>
          <el-form-item class="r-20" prop="userName">
            <el-input
              v-model.trim="queryForm.userName"
              @keyup.enter.native="query"
              placeholder="使用人"
            ></el-input>
          </el-form-item>
          <el-form-item class="r-20" prop="isExceedDay" label="是否超过24小时">
            <el-select
              v-model="queryForm.isExceedDay"
              placeholder="请选择是否超过24小时"
            >
              <el-option
                v-for="item in overList"
                :value="item.id"
                :label="item.label"
                :key="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="r-20" prop="dynamoResult" label="发电结果">
            <el-select
              v-model="queryForm.dynamoResult"
              placeholder="请选择发电结果"
            >
              <el-option
                v-for="item in powerResultList"
                :value="item.id"
                :label="item.label"
                :key="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </div>
        <div style="margin-bottom:20px">
          <el-button type="primary" @click.stop="exportButton">导出</el-button>
        </div>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
      >
        <el-table-column
          width="20"
          align="center"
          style="padding: 0"
        ></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column
          prop="subjectNum"
          label="工单编号"
          min-width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="plateNum"
          label="发电车辆"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="userName" label="使用人" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div v-if="row.userName != ''">{{ row.userName }}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="dept"
          label="归属部门"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="dispatchTime"
          label="派单时间"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="receiptTime"
          label="回单时间"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="dynamoCount"
          label="发电记录数"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="dynamoTime"
          label="发电时长（小时）"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="exceedDay"
          label="是否超过24小时"
          min-width="140"
          show-overflow-tooltip
        >
          <template slot="header">
            <span>是否超过24小时</span>
            <span @click="overHourSort" class="iconfont icon-sort"></span>
          </template>
          <template slot-scope="{ row }">
            <div v-if="row.exceedDay">是</div>
            <div v-else-if="!row.exceedDay">否</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="dynamoEnergy"
          label="发电量（kW·h）"
          min-width="140"
          show-overflow-tooltip
        >
          <template slot="header">
            <span>发电量（kW·h）</span>
            <span @click="capacitySort" class="iconfont icon-sort"></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dynamoOil"
          label="发电油耗（L）"
          min-width="130"
          show-overflow-tooltip
        >
          <template slot="header">
            <span>发电油耗（L）</span>
            <span @click="oilSort" class="iconfont icon-sort"></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiptState"
          label="回单结果"
          min-width="140"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <div v-if="row.receiptState == 1">未完成发电</div>
            <div v-else-if="row.receiptState == 2">完成发电</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiptMessage"
          label="未完成原因"
          min-width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="powerDetail(row)"
              >发电记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "PowerRecordMore",
  data() {
    return {
      queryForm: {
        subjectNum: "",
        plateNum: "",
        userName: "",
        isExceedDay: 0,
        dynamoResult: 0,
      },
      rowData: {},
      tableData: [],
      overList: [
        { id: 0, label: "全部", value: 0 },
        { id: 1, label: "是", value: 1 },
        { id: 2, label: "否", value: 2 },
      ],
      powerResultList: [
        { id: 0, label: "全部", value: 0 },
        { id: 1, label: "未完成发电", value: 1 },
        { id: 2, label: "完成发电", value: 2 },
      ],
      dynamoResult: 0,
      dynamoTimeSort: 0,
      dynamoEnergySort: 0,
      dynamoOilSort: 0,
      total: 0,
      currentPage: 1,
      limit: 10,
    };
  },
  created() {
    let currentPage = this.$route.params.currentPage;
    if (currentPage) {
      this.currentPage = parseInt(currentPage);
    }
    let vehicleInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let rowData = this.$route.params.data || vehicleInfo;
    this.rowData = rowData;
    this.getTableData();
  },
  methods: {
    query() {
      this.getTableData();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getTableData();
    },
    goBack() {
      this.$router.push({
        name: "BaseStationPowerRecord",
        params: {
          currentPage: sessionStorage.getItem("baseCurrentPage"),
        },
      });
    },
    powerDetail(row) {
      this.$router.push({
        name: "PowerDetail",
        params: { data: row },
      });
      if (sessionStorage.getItem("workOrderInfo") != "") {
        sessionStorage.removeItem("workOrderInfo");
      }
      sessionStorage.setItem("powerRecordCurrentPage", this.currentPage);
      sessionStorage.setItem("workOrderInfo", JSON.stringify(row));
    },
    overHourSort() {
      this.exceedDynamoCountSort = this.exceedDynamoCountSort == 1 ? 2 : 1;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = 0;
      this.getTableData();
    },
    capacitySort() {
      this.exceedDynamoCountSort = 0;
      this.dynamoEnergySort = this.dynamoEnergySort == 1 ? 2 : 1;
      this.dynamoOilSort = 0;
      this.getTableData();
    },
    oilSort() {
      this.exceedDynamoCountSort = 0;
      this.dynamoEnergySort = 0;
      this.dynamoOilSort = this.dynamoOilSort == 1 ? 2 : 1;
      this.getTableData();
    },
    exportButton() {
      let _this = this;
      let url = "";
      url =
        "/api/base/station/Statistics/detailList/export?id=" +
        _this.rowData.id +
        "&subjectNum=" +
        _this.queryForm.subjectNum +
        "&plateNum=" +
        _this.queryForm.plateNum +
        "&userName=" +
        _this.queryForm.userName +
        "&isExceedDay=" +
        _this.queryForm.isExceedDay +
        "&dynamoResult=" +
        _this.queryForm.dynamoResult;
      window.location.href = url;
    },
    async getTableData() {
      let obj = {};
      obj.subjectNum = this.queryForm.subjectNum;
      obj.plateNum = this.queryForm.plateNum;
      obj.userName = this.queryForm.userName;
      obj.isExceedDay = this.queryForm.isExceedDay;
      obj.dynamoResult = this.queryForm.dynamoResult;
      obj.exceedDynamoCountSort = this.exceedDynamoCountSort;
      obj.dynamoEnergySort = this.dynamoEnergySort;
      obj.dynamoOilSort = this.dynamoOilSort;
      obj.id = this.rowData.id;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let { data: res } = await this.$axios.get(
        "/api/base/station/Statistics/dynamo/detailList",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.powerRecordMore-container {
  height: calc(100% - 60px);
  padding-bottom: 20px;
  margin: 20px;
  background: #f8f8f8;
  .top {
    margin-bottom: 20px;
    .top-container {
      margin-top: 20px;
    }
  }
  // .top ::-webkit-scrollbar {
  //   /*滚动条整体样式*/
  //   width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
  //   height: 6px;
  // }
  // .top ::-webkit-scrollbar-thumb {
  //   /*滚动条里面小方块*/
  //   border-radius: 2px;
  //   box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  //   background: #999;
  // }
  // .top ::-webkit-scrollbar-track {
  //   /*滚动条里面轨道*/
  //   box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  //   border-radius: 2px;
  //   background: #ededed;
  // }
  .table {
    width: 100%;
    font-size: 14px;
    color: #333;
    overflow-x: auto;
    .table-top {
      display: flex;
      .el-col {
        line-height: 38px;
        min-width: 200px;
        text-align: center;
        padding: 0 5px !important;
        border: 1px solid #ccc;
        background: #f4f4f4;
      }
    }
    .table-bottom {
      display: flex;
      .el-col {
        line-height: 38px;
        min-width: 200px;
        text-align: center;
        padding: 0 5px !important;
        border: 1px solid #ccc;
        border-top: none;
        background: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .bottom {
    padding: 20px;
    background: #fff;
  }
}
</style>
